import { render, staticRenderFns } from "./tablesConfig.vue?vue&type=template&id=45048858&scoped=true"
import script from "./tablesConfig.vue?vue&type=script&lang=js"
export * from "./tablesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45048858",
  null
  
)

export default component.exports